import api from '@/api'
import axios from 'axios'

//获取商品列表
export async function getProducts(params) {

  return api.post('api/services/app/FrontendProduct/SearchKeyWords', params);
}

export async function getProduct(data) {
 return api.get('api/services/app/FrontendProduct/GetProductDetails?Id='+data.id+'&isPC=true')
}

export async function getWaitAuditProduct(data) {
 return api.get('api/services/app/FrontendProduct/GetWaitAuditProductDetails?Id='+data.id)
}

export async function collect(data) {
  return api.post('api/services/app/FrontendProduct/Collect', data)
 }

 export async function removeCollect(data) {
  return api.delete('api/services/app/FrontendProduct/RemoveCollect?id='+data.id, data)
 }

 export async function batchRemoveCollect(data) {
  return api.post('api/services/app/FrontendProduct/BatchRemoveCollect', data)
 }

 //获取收藏商品列表
export async function getCollectProducts(param) {
  var paramStr='SkipCount='+ (param.SkipCount>0?param.SkipCount-1:param.SkipCount);
  paramStr += '&MaxResultCount='+ param.MaxResultCount;
  return api.get('api/services/app/FrontendProduct/GetMyCollectProducts?'+paramStr);
}

 //获取商品评价列表
 export async function getProductEvaluates(param) {
  var paramStr='SkipCount='+ (param.SkipCount>0?param.SkipCount-1:param.SkipCount);
  paramStr += '&MaxResultCount='+ param.MaxResultCount;
  paramStr += '&ProductId='+param.ProductId;
  return api.get('api/services/app/FrontendProduct/GetProductEvaluates?'+paramStr);
}


// WEBPACK FOOTER //
// ./src/api/productDetail.js